import type { TUnionType } from './models';

/**
 * Заменяет точку на запятую в дробных числа, не разбивая тысячи на группы
 */
export const getCommaSeparation = (value: TUnionType): string => {
    if (!value || Number.isNaN(Math.abs(Number(value))) || value.toString().split('.').length > 2) {
        // TODO log: Push a correct arg (number or number string) to getCommaSeparation function
        return '';
    }

    return Number(value).toLocaleString('ru-RU', {
        maximumFractionDigits: 10,
        useGrouping: false,
    });
};
